import { RepositoryFactory } from "repository/RepositoryFactory";
import firebase from "../../config/firebase";
import { toast } from "react-toastify";

export const getWallet = (userId) => async (dispatch) => {
  dispatch(IsLoader(true));

  return firebase
    .firestore()
    .collection("wallet")
    .where("userId", "==", userId)
    .onSnapshot(
      (snapshot) => {
        const walletData = [];
        snapshot.forEach((doc) => {
          walletData.push({ id: doc.id, ...doc.data() });
        });

        const wallet = walletData[0];

        dispatch({
          type: "FETCH_WALLET",
          payload: wallet
            ? { amount: wallet.amount ?? 0, id: wallet.id ?? null }
            : { amount: 0, id: null },
        });

        dispatch(IsLoader(false));
      },
      (error) => {
        dispatch(IsLoader(false));
      }
    );
};


export const getWalletLog =
  (userId, lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      let wallet = firebase
        .firestore()
        .collection("wallet_logs")
        .where("userId", "==", userId)
        .orderBy("createdAt");
      if (lastDocument !== "") {
        wallet = wallet.startAfter(lastDocument);
      }
      wallet
        .limit(10)
        .get()
        .then(async (query) => {
          let walletData = [];

          for await (let doc of query.docs) {
            walletData.push({ id: doc.id, ...doc.data() });
          }

          dispatch({
            type:
              lastDocument != ""
                ? "MORE_FETCH_WALLET_LOGS"
                : "FETCH_WALLET_LOGS",
            payload: {
              data: walletData,
              lastDocument: query.docs[walletData.length - 1],
              hasMoreDocument: walletData.length >= 10,
            },
          });
        });
    } catch (error) {
    } finally {
      onComplete();
    }
  };

export const IsLoader = (val) => async (dispatch) => {
  dispatch({
    type: "SET_IS_LOADING",
    payload: val,
  });
};

export const withdrawRequest =
  (amount, userId, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      const withdrawRepository = RepositoryFactory.get("setWithdraw");
      await withdrawRepository.setWithdraw({ amount, userId });
      onComplete();
      toast.success("Withdrawl request sucessfully");
    } catch (error) {
    }
  };


export const fetchCoinsStats =
  (id, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      const fetchCoins = RepositoryFactory.get("getCoinsStats");

      const response = await fetchCoins.getCoinsStats(id);

      const transactions = response.data?.data?.transactions || [];

      dispatch({
        type: "SET_COINS_STATS",
        payload: transactions,
      });
      onComplete();
    } catch (error) {
      onComplete();
    }
  };

export const fetchCoinsLimit =
  (onComplete = () => {}) =>
  async (dispatch) => {
    try {
      const fetchCoinsLimit = RepositoryFactory.get("getCoinsStats");

      const response = await fetchCoinsLimit.getCoinsLimit();
      const limit = response.data?.data?.maxLimitReached;

      dispatch({
        type: "SET_COINS_STATS_LIMIT",
        payload: limit,
      });
      onComplete();
    } catch (error) {
      onComplete();
    }
  };
